<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // eslint-disable-next-line vue/require-default-prop
    option: {
      type: Array,
    },
  },
}
</script>

<template>
  <div class="custom-control custom-checkbox d-inline-block px-2">
    <label :for="option" class="ml-3 custom-control-label">
      <input
        :id="option"
        type="checkbox"
        :name="name"
        class="w-auto mr-2 custom-control-input"
        :checked="value"
        :disabled="disabled"
        @change="$emit('input', $event.target.checked)"
      />
      {{ label }}
    </label>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
